var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.iframeLoaded)?_c('v-progress-linear',{staticClass:"ma-0",attrs:{"indeterminate":true,"active":_vm.iframeLoaded}}):_vm._e(),_c('iframe',{attrs:{"src":_vm.src},on:{"load":_vm.load}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }